<template>
    <div id="tryout-group">
        <ol class="breadcrumb pull-right">
            <li>
                <router-link :to="{ path: '/' }">Home</router-link>
            </li>
            <li class="active">Modul pembelajaran</li>
        </ol>

        <h1 class="page-header">Daftar Modul Pembelajaran</h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <div class="btn-group pull-right">
                            <button
                                type="button"
                                class="btn btn-success btn-xs"
                                @click="createModulBelajar()"
                            >
                                <span class="fa fa-plus"></span> Modul
                                Pembelajaran
                            </button>
                        </div>
                        <h4 class="panel-title">Modul Pembelajaran</h4>
                    </div>
                    <div class="panel-body">
                        <app-datatable
                            :items="Moduls"
                            :has-action="true"
                            :has-custom-search="false"
                            :headers="headers"
                            :key="tableKey"
                            v-on:selected="selectedRow = $event"
                            v-on:dblClicked="editModulBelajar()"
                            v-on:deleted="deleteModulBelajar($event)"
                            v-on:changePage="
                                pagination = {
                                    ...pagination,
                                    currentPage: $event,
                                }
                            "
                            v-on:changeSortMode="
                                pagination = { ...pagination, sortMode: $event }
                            "
                            v-on:doSearch="
                                search = {
                                    query: $event.value,
                                    by: headersKey[$event.key],
                                }
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable";
import ModulPembelajaranService from "@/modules/modul_belajar_2022/services/modulpembelajaran.js";
import Moment from "moment";

export default {
    name: "live-class",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            tableKey: 0,
            Moduls: [
                {
                    id: 1,
                    data: {
                        title: "Pendalaman Materi Persamaan Linear",
                        description: "Pendalaman Materi Persamaan Linear",
                        subject: "Matematika",
                        mapel: 1,
                        join_code: "",
                        is_private: false,
                        grade: [11, 12],
                        url: null,
                        level: "SMA",
                        grade: "10",
                        created_at: Moment(1608209700000).format("YYYY-MM-DD"),
                    },
                },
            ],
            selectedRow: null,
            isLoading: false,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: ["Nama", "Mapel", "Kelas", "Status", "Created At"],
            headersKey: ["name", "mapel", "grades", "status", "created_at"],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {},

    methods: {
        fetchData: function () {
            var context = this;
            var search = null;
            this.isLoading = true;

            if (
                !_.isEmpty(this.$store.state.datatable.filter) &&
                this.$store.state.datatable.pageBefore ==
                    "ModulPembelajaranForm"
            ) {
                search = {
                    query: this.$store.state.datatable.filter.value,
                    by: this.headersKey[this.$store.state.datatable.filter.key],
                };
            } else {
                search = this.search;
            }

            ModulPembelajaranService.getListModul(function (result) {
                context.Moduls = [];

                if (result.success) {
                    result.data.forEach(function (group) {
                        var createdAt = Moment(group.created_at).format(
                            "YYYY-MM-DD",
                        );
                        var row = {
                            id: group.id,
                            data: [
                                group.name,
                                group.subject,
                                group.grades
                                    .toString()
                                    .replace(/[\[\]']+/g, ""),
                                group.status,
                                createdAt,
                            ],
                            datas: group,
                        };

                        context.Moduls.push(row);
                        context.Moduls = context.Moduls.filter(
                            (s) => !s.datas.bab,
                        );

                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        createModulBelajar: function () {
            this.$router.push({ path: "/modul-pembelajaran-old/form" });
        },

        editModulBelajar: function () {
            var context = this;
            context.isLoading = true;
            var groupId = this.selectedRow.datas.id;

            ModulPembelajaranService.getModulBelajar(
                groupId,
                function (result) {
                    if (result.success) {
                        var ModulBelajar = result.data;
                        context.$store.commit(
                            "modul_pembelajaran_init",
                            ModulBelajar,
                        );
                        console.log(context.$store.state.modulpembelajaran);
                        context.$router.push({
                            path: "/modul-pembelajaran-old/form",
                            query: { id: groupId },
                        });
                    }
                    context.isLoading = false;
                },
            );
        },

        deleteModulBelajar: function (tryout) {
            var context = this;
            var groupId = tryout.datas.id;

            var confirmed = window.confirm(
                "Apakah anda yakin akan menghapus Modul Belajar ini?",
            );

            if (confirmed) {
                ModulPembelajaranService.deleteModulPembelajaran(
                    groupId,
                    function (result) {
                        if (result.success) {
                            alert("Berhasil menghapus data!");
                            context.fetchData();
                        }
                        context.isLoading = false;
                    },
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// ModulBelajar.vue?fb919f42